<div class="container-tig-item">
    <div class="help-c-title">
        <h4>蒙古文无衬线报体与蒙古文报体比较</h4>
    </div>
    <div>
        <p>一、很多用户误以为蒙古文无衬线报体和蒙古文报体是同一种字体，其实这两种字体看起来相似， 但是蒙古文无衬线报体的笔画比蒙古文报体纤细之外笔画上还有很多不同之处。下面把同字号大 小的同一个字用两种字体比较来举几个例子：</p>
        <br>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/1.jpg" alt="Onon字体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/2.jpg" alt="Onon字体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/3.jpg" alt="Onon字体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/4.jpg" alt="Onon字体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/5.jpg" alt="Onon字体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/6.jpg" alt="Onon字体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/7.jpg" alt="Onon字体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/8.jpg" alt="Onon字体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/9.jpg" alt="Onon字体 - 图片">
        </div>

    </div>
    <div>
        <p>通过比较发现两种字体在很多笔画上有区别，尤其是《牙》和《尾》的区别很明显。比如：</p>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/10.jpg" alt="Onon字体 - 图片">
        </div>
    </div>
    <p>蒙古文报体的不管是《牙》还是《尾》它本身的粗细不一样，但是蒙古文无衬线报体的《牙》和 《尾》本身的粗细一样大，那么它的优点在于小字号，字体像素低的情况下辨识度高，易于阅读。</p>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/11.jpg" alt="Onon字体 - 图片">
        </div>
    </div>
    <p>二、蒙古文无衬线报体的笔画纤细、结构简单且紧凑、线条流畅。那么它的优点在于有限的面积里 文字内容多的情况下对整体内容来说没那么挤，可读性强，视觉效果更好。下面与蒙古文报体比较 举例（两种字体同字号、同行间距、同一段内容在同大小的面积）。 </p>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/12.jpg" alt="Onon字体 - 图片">
            <div>蒙古文报体</div>
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsBot/13.jpg" alt="Onon字体 - 图片">
            <div>蒙古文无衬线报体</div>
        </div>
    </div>
    <p>三、总结：蒙古文无衬线报体特点一，笔画纤细、结构简单且紧凑线条流畅、优点是可读性强，视 觉效果。特点二，每个笔画的粗细几乎一样大，优点是小字号，低像素情况下辨识度高，易于阅 读。在小字号可读性方面有“先天”优势。</p>
    <br>
    <br>
</div>